import React from 'react';
import * as S from './Questions.styles';
import { QuestionsProps } from './Questions.types';
import { PlainPlusIcon } from '@/components/UI/Icons/Icons';

export const Questions = ({ title, questions }: QuestionsProps) => (
  <S.Box>
    <S.Title $variant="1">{title}</S.Title>
    {questions.map(item => (
      <S.Question key={item.id} id={`faq-question-${item.anchor}`}>
        <S.QuestionToggle
          type="button"
          onClick={item.onToggle}
          aria-expanded={item.isOpen}
          id={`faq-toggle-${item.anchor}`}
        >
          {item.question}
          <PlainPlusIcon aria-hidden="true" />
        </S.QuestionToggle>
        {item.isOpen && (
          <S.Answer id={`faq-answer-${item.anchor}`}>
            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
          </S.Answer>
        )}
      </S.Question>
    ))}
  </S.Box>
);
